import React from 'react';
import { ShieldCheck } from 'lucide-react';
import './PassportIdentityBadge.css';

/**
 * External-only trust seal for Compliance Passport views.
 * Renders ONLY when identityVerified === true. False / missing / undefined → nothing in the DOM.
 * Do not pass raw identity status strings here — the backend collapses those to this boolean.
 */
export default function PassportIdentityBadge({ identityVerified }) {
  if (identityVerified !== true) return null;

  return (
    <span className="passport-identity-trust" role="status">
      <ShieldCheck size={14} aria-hidden="true" />
      Identity Verified
    </span>
  );
}
